import { render } from "./gphg.vue?vue&type=template&id=fce82ae2&scoped=true&ts=true"
import script from "./gphg.vue?vue&type=script&lang=ts"
export * from "./gphg.vue?vue&type=script&lang=ts"

import "./gphg.vue?vue&type=style&index=0&id=fce82ae2&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce82ae2"]])

export default __exports__